/**
 * This screen is used to show page not found when a user attempts to open incorrect URL.
 */
import { Button, Container, Typography, Box } from "@mui/material";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  async function handleBackToHome() {
    navigate("/");
  }

  return (
    <Container maxWidth="xl" sx={{ paddingY: 2 }}>
      <Box
        minHeight="70vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Typography variant="h6" textAlign="center">
          <Trans
            i18nKey="notFound.notFoundMessage"
            components={{ br: <br /> }}
          />
        </Typography>
        <Button variant="contained" size="large" onClick={handleBackToHome}>
          {t("notFound.backToHome")}
        </Button>
      </Box>
    </Container>
  );
}

export default NotFound;
